<i18n
  src="@/locales/views/customer/query/basic_containers/list_containers.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/exportation.yml" lang="yaml"></i18n>

<template>
  <go-back-link
    :text="$t('labels.go-back-link')"
    :name="routeName('')"
    :params="{
      customer_id: customer_id
    }"
  />

  <bread-crumbs :labels="[module_name, agro_exporter?.name]"></bread-crumbs>

  <template v-if="load_data_general">
    <div class="flex flex-row justify-start">
      <div class="panel-plain-label">
        <badge-default
          :label="
            containers.length + ' ' + $t('labels.total_number_containers')
          "
        />
        <span class="space-actions" />
        <exportation-status
          :status_id="0"
          :prepend_label="' ' + numContainersStatus0"
        />
        <span class="space-actions" />
        <exportation-status
          :status_id="1"
          :prepend_label="' ' + numContainersStatus1"
        />
        <span class="space-actions" />
        <exportation-status
          :status_id="2"
          :prepend_label="' ' + numContainersStatus2"
        />
      </div>
    </div>
    <div class="mt-8 flex flex-col">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.week") }}
                  </th>
                  <th scope="col" class="table-header-cell">

                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.exportation") }}
                  </th>

                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.status") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.departured_at") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.origin_export") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.container") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    <i class="fa-solid fa-paperclip"></i>
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.crop") }}
                  </th>

                  <th scope="col" class="table-header-cell"></th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="container in containers"
                  :key="container.id"
                >
                  <td class="table-cell">{{ container.exportation?.week }}</td>
                  <td class="table-cell">
                    <exportation-type v-if="(container.exportation != null)" :exportation_type_id="container.exportation.exportation_type_id" :only_icon="true" />
                  </td>
                  <td class="table-cell-main link" @click.prevent="goToShow(container)">
                    {{ container.exportation?.booking_code }}
                  </td>
                  <td class="table-cell">
                    <exportation-status
                      :status_id="container.exportation?.status_id"
                    />
                  </td>
                  <td class="table-cell">
                    {{ dateFormatter(container.exportation?.departured_at) }}
                  </td>

                  <td class="table-cell">
                    {{ container.exportation?.origin_export.name }}
                  </td>

                  <td class="table-cell-main link" @click.prevent="goToShow(container)">
                    {{ container.container_code }}
                  </td>

                  <td class="table-cell">
                    {{ container.num_attachments}}
                  </td>

                  <td class="table-cell">
                    {{ container.crop.name }}
                  </td>

                  <td class="table-cell-action">
                    <a class="link" @click.prevent="goToShow(container)"
                      ><i class="fa-solid fa-eye"></i
                      ><span class="space-icon"></span
                      >{{ $t("labels.show_link") }}</a
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </template>
  <template v-else>
    <loading-message />
  </template>
</template>

<script>
import Requester from "@/views/customer/requesters/query/basic_containers/list_containers.js";
import ExportationStatus from "@/components/views/agro_exporter/production/shared/exportation/ExportationStatus.vue";
import ExportationType from "@/components/views/agro_exporter/production/shared/exportation/ExportationType.vue";

export default {
  name: "CustomerQueryBasicContainersListContainers",
  components: {
    ExportationStatus,
    ExportationType
  },
  props: {
    customer_id: { required: true },
    agro_exporter_id: { required: true }
  },
  data: function () {
    return {
      containers: [],
      agro_exporter: null,
      load_data_general: false
    };
  },
  computed: {
    numContainersStatus0: function () {
      return this.containers.filter(
        container => container.exportation?.status_id == 0
      ).length;
    },
    numContainersStatus1: function () {
      return this.containers.filter(
        container => container.exportation?.status_id == 1
      ).length;
    },
    numContainersStatus2: function () {
      return this.containers.filter(
        container => container.exportation?.status_id == 2
      ).length;
    }
  },
  methods: {
    fetchAgroExporter: async function () {
      const response = await Requester.fetchAgroExporter(
        this.customer_id,
        this.agro_exporter_id
      );
      this.agro_exporter = response.data;
    },
    fetchContainers: async function () {
      const response = await Requester.fetchContainers(
        this.customer_id,
        this.agro_exporter_id
      );
      this.containers = response.data;
      this.load_data_general = true;
    },
    goToShow: function (container) {
      this.$router.push({
        name: this.routeName("show_container"),
        params: {
          customer_id: this.customer_id,
          container_id: container.id
        }
      });
    }
  },
  created: function () {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          customer_id: this.customer_id
        }
      }).then(() => {
        this.fetchAgroExporter();
        this.fetchContainers();
      })
    );
  }
};
</script>
